"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRow = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const table_context_1 = require("./table-context");
const table_row_selection_1 = require("./table-row-selection");
const table_types_1 = require("./table-types");
exports.TableRow = (0, react_1.memo)(function TableFieldRow({ index, value, rowStyle }) {
    const { filteredColumns, handleRowClick, showSelectBox, sorts, classes } = (0, react_1.useContext)(table_context_1.TableContext);
    const { activeRow } = (0, react_1.useContext)(table_context_1.TableSelectedContext);
    const defaultValueMapper = (0, event_callback_hook_1.useEventCallback)(({ value }) => value);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.row, {
            [classes.rowActive]: activeRow === value.id,
        }), style: rowStyle, onClick: () => handleRowClick(value.id) },
        showSelectBox && (react_1.default.createElement("div", { className: classes.tableRowActions },
            react_1.default.createElement(table_row_selection_1.TableRowSelection, { value: value }))),
        filteredColumns.map((column, i) => {
            var _a;
            const { CellComponent, valueMapper = defaultValueMapper } = column;
            return (react_1.default.createElement("div", { key: i, className: (0, clsx_1.default)(classes.cellWrapper, {
                    [classes.columnAlignLeft]: column.align === table_types_1.TableColumnAlign.LEFT,
                    [classes.columnAlignRight]: column.align === table_types_1.TableColumnAlign.RIGHT,
                    [classes.columnAlignCenter]: column.align === table_types_1.TableColumnAlign.CENTER,
                }), style: {
                    width: column.width,
                } },
                react_1.default.createElement(CellComponent, { index: index, value: valueMapper({
                        rowValue: value,
                        column,
                        value: (0, lodash_1.get)(value, (_a = column.displaykey) !== null && _a !== void 0 ? _a : column.datakey, null),
                        sorts,
                    }), rowValue: value, column: column })));
        })));
});
//# sourceMappingURL=table-row.js.map